export const BASE_API_URL = "https://elexyt2024.site";
//export const BASE_API_URL = "http://122.166.195.74";

